<script setup lang="ts">
const p = usePortfolioStore().profile
</script>

<template>
  <section id="about" class="px-1 py-8 md:py-12">
    <h2 data-reveal class="text-2xl font-extrabold md:text-3xl"><span class="text-accent">درباره</span> من</h2>
    <p data-reveal class="mt-4 max-w-3xl text-[15px] leading-9 text-soft">{{ p.about }}</p>
    <!-- <div class="mt-5 grid gap-5 md:grid-cols-2">
      <p v-for="(t, i) in p.about" :key="i" data-reveal class="text-sm leading-8 text-muted">{{ t }}</p>
    </div> -->
  </section>
</template>
